import type { VestingDocumentIndicator } from 'types/api-responses';
import type { WorkspaceTract } from '../types';

/**
 * The deed a vesting pill links to: none when there is no document or its state is none.
 * @param {VestingDocumentIndicator | null} indicator - The tract's vesting document
 * @param {WorkspaceTract['vestingState']} state - Its vesting state
 * @return {string | null} The deed's path
 */
export const vestingPillHref = (
  indicator: VestingDocumentIndicator | null,
  state: WorkspaceTract['vestingState']
) => (!indicator || state === 'none' ? null : indicator.documentHref);
